import React from "react";
import { Modal as AntdModal, ModalProps } from "antd";
import { useModalContext } from "utils/providerMigration";
import { isFunction } from "utils/lodash";
import cx from "classnames";

interface _ModalProps extends ModalProps {
  transparent?: boolean;
}
const Modal: React.FC<_ModalProps> = ({
  title = "",
  children,
  className,
  closable,
  onCancel,
  transparent,
  ...props
}) => {
  const { modalService } = useModalContext();
  const _onCancel = (e: any) => {
    if (isFunction(onCancel)) {
      onCancel(e);
    }
    if (!!closable) {
      modalService.removeDOM(200);
    }
  };
  return (
    <AntdModal
      closable={closable}
      className={cx(className)}
      open={modalService.visible}
      title={title}
      footer={null}
      onCancel={_onCancel}
      styles={transparent ? {
        content: {
          backgroundColor: 'transparent',
          boxShadow: 'none'
        },
        wrapper: {
          paddingBottom: 0
        }
      } : {
        wrapper: {
          paddingBottom: 0
        }
      }}
      {...props}
    >
      {children}
    </AntdModal>
  );
};

export default Modal;
